var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-tab',{attrs:{"id":_vm.id,"md-label":_vm.label,"to":_vm.to,"exact":_vm.exact,"md-disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }